import coreModals from '../../../core/views/modals';

const registeredModals = {
	...coreModals,
	search: () => import(/* webpackPrefetch: true */ '/views/modals/search'),
	locations: () => import('/views/modals/locations'),
};

export default registeredModals;
